import { Routes } from '@angular/router';
import { DESIGN_CROSSES_PERMISSIONS } from '../shared/auth/permissions';
import { RouteAccessService } from '../shared';
import { DesignCrossesComponent } from './design-crosses.component';
import { SourceListComponent } from './source-list.component';

export const DESIGN_CROSSES_ROUTES_ROOT: Routes = [
    {
        path: 'design-crosses',
        component: DesignCrossesComponent,
        children: [
            {
                path: '',
                redirectTo: 'design-crosses-study-list',
                pathMatch: 'full'
            },
            {
                path: 'design-crosses-study-list',
                component: SourceListComponent,
                data: {
                    authorities: [...DESIGN_CROSSES_PERMISSIONS],
                    pageTitle: 'design-crosses.title' },
                canActivate: [RouteAccessService]
            },
            {
                /**
                 * :listId param is to track active link, but listId queryParam is actually used to open tabs
                 * because it's also available to parent (and all) component
                 */
                path: 'list/:listId',
                component: SourceListComponent,
                data: {
                    authorities: [...DESIGN_CROSSES_PERMISSIONS],
                    pageTitle: 'design-crosses.title' },
                canActivate: [RouteAccessService]
            }
        ]
    }
];

export const DESIGN_CROSSES_ROUTES: Routes = [
    {
        path: 'design-crosses-main',
        component: DesignCrossesComponent,
        children: [
            {
                path: '',
                redirectTo: 'design-crosses-study-list',
                pathMatch: 'full'
            },
            {
                path: 'design-crosses-study-list',
                component: SourceListComponent,
                data: {
                    authorities: [...DESIGN_CROSSES_PERMISSIONS],
                    pageTitle: 'design-crosses.title' },
                canActivate: [RouteAccessService]
            },
            {
                /**
                 * :listId param is to track active link, but listId queryParam is actually used to open tabs
                 * because it's also available to parent (and all) component
                 */
                path: 'list/:listId',
                component: SourceListComponent,
                data: {
                    authorities: [...DESIGN_CROSSES_PERMISSIONS],
                    pageTitle: 'design-crosses.title' },
                canActivate: [RouteAccessService]
            }
        ]
    }
];
